import React, { useEffect, useState } from 'react';
import icons from '../../../../icons';
import style from './OptionSelection.module.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { useRef, useContext } from 'react';
import Banner from '../../../Banner/Banner';
import TextButton from '../../../Buttons/TextButton/TextButton';
import Checkbox from '../../../Checkbox/Checkbox';
import { AppContext } from '../../../../AppContext';


const OptionSelection = props => {
    const { setPage, subjects, flashCards } = useContext(AppContext);

    return <main className={ style.main } style={{ height: props.option && "100vh" }}>
        { (() => {
            switch (props.option) {
                case "subject":
                    return <>
                        <section className={ style.topSection }>
                            <div className={ style.flex }>
                                <img src={ icons.arrow_left_icon } className={ style.backIcon } onClick={ props.back }></img>
                                <h2>Scegli la <span style={{ color: "var(--orange)" }}>materia</span></h2>
                                <img src={ icons.add_icon } className={ style.addIcon } onClick={ () => setPage({ page: "menu", menuPage: "subjects", from: "add" }) }></img>
                            </div>
                            <h3 className={ style.subHeader }>O aggiungine una nuova</h3>
                            <Banner />
                        </section>
                        <div className={ style.subjects }>
                            { subjects && Object.values(subjects).map(subject => <div key={ subject.subject } className={ style.subject } onClick={ () => props.select(subject.subject) }>
                                <img src={ icons[subject.icon] } className={ style.subjectIcon }></img>
                                <h3 className={ style.subjectName }>{ subject.subject }</h3>
                            </div>) }
                        </div>
                    </>;
                case "category":
                    return <>
                        <section className={ style.topSection }>
                            <div className={ style.flex }>
                                <img src={ icons.arrow_left_icon } className={ style.backIcon } onClick={ props.back }></img>
                                <h2 style={{ marginTop: ".5rem" }}>Scegli la <span style={{ color: "var(--orange)" }}>categoria</span></h2>
                            </div>
                            <Banner />
                        </section>
                        <div className={ style.subjects }>
                            { flashCards && Object.values(flashCards).map(category => <div key={ category.id } className={ style.subject } onClick={ () => props.select(category.id) }>
                                <img src={ icons[subjects[category.subject]?.icon] ?? icons.question_mark_orange_icon } className={ style.subjectIcon }></img>
                                <h3 className={ style.subjectName }>{ category.name }</h3>
                            </div>) }
                        </div>
                    </>;
                case "type":
                    return <>
                        <section className={ style.topSection }>
                            <div className={ style.flex }>
                                <img src={ icons.arrow_left_icon } className={ style.backIcon } onClick={ props.back }></img>
                                <h2 style={{ marginTop: ".5rem" }}>Scegli il <span style={{ color: "var(--orange)" }}>tipo</span></h2>
                            </div>
                            <Banner style={{ marginTop: "1rem" }} />
                        </section>
                        <div className={ style.subjects }>
                            <div className={ style.subject } onClick={ () => props.select("category") }>
                                <img src={ icons.test_icon } className={ style.subjectIcon }></img>
                                <h3 className={ style.subjectName }>Categoria</h3>
                            </div>
                            <div className={ style.subject } onClick={ () => props.select("flashcard") }>
                                <img src={ icons.flashcards_icon } className={ style.subjectIcon }></img>
                                <h3 className={ style.subjectName }>Flashcard</h3>
                            </div>
                        </div>
                    </>;
            }
        })() }
    </main>
};

export default OptionSelection;
